<template>
  <section>
    <div class="contentBlock">
      <AccesskeyLink
        id="mainContent"
        class="accesskey-c"
        accesskey="C"
        title=":::主要內容顯示區"
      />
      <p class="title">登入</p>
      <button
        @click="FBlogin"
        class="loginBtn fbLayout"
        title="[另開新分頁]前往FB登入"
      >
        <img :src="facebook" alt="臉書" class="facebookLogo" />
        Facebook登入
      </button>
      <div class="divider">或</div>
      <form @submit="loginRequest">
        <div class="formBlock">
          <label class="formLabel"
            >帳號
            <input
              type="text"
              class="inputLayout"
              placeholder="請輸入電子信箱"
              aria-label="會員帳號，請輸入電子信箱"
              v-model="user.email"
            />
          </label>
          <label class="formLabel"
            >密碼
            <input
              type="password"
              class="inputLayout"
              aria-label="會員密碼，請輸入密碼"
              placeholder="請輸入密碼"
              v-model="user.password"
            />
          </label>
        </div>
        <button @click="loginRequest" class="loginBtn loginLayout" title="登入">
          登入
        </button>
      </form>
      <div class="additionAction">
        <router-link :to="{ name: 'forgot-password' }" title="忘記密碼"
          >忘記密碼？</router-link
        >
        <router-link :to="{ name: 'register' }" title="[前往]註冊頁面"
          >還未加入？ 點此註冊</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
import facebook from "@/assets/images/member-system/FB_icon.svg";
import AccesskeyLink from "@/components/a11y/AccesskeyLink.vue";

export default {
  name: "MemberLogin",
  metaInfo() {
    return {
      title: "會員登入",
    };
  },
  data() {
    return {
      user: {
        email: "",
        password: "",
        role: "101",
      },
      facebook,
    };
  },
  created() {
    window.fbAsyncInit = function () {
      FB.init({
        appId: "510483459734954",
        xfbml: true,
        version: "v5.0",
      });
      FB.AppEvents.logPageView();
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  },
  mounted() {},
  methods: {
    isInputRequired() {
      if (this.user.email === "" || this.user.password === "") {
        alert("請填入信箱和密碼");
        return false;
      }
      return true;
    },
    loginRequest(e) {
      e.preventDefault();

      if (this.isInputRequired()) {
        this.$store
          .dispatch("loginRequest", this.user)
          .then(() => {
            window.alert("已登入，重新跳轉頁面");
            this.$router.push(this.$route.query.redirect || "/");
          })
          .catch((e) => {
            alert("登入失敗");
            this.$router.push(this.$route.query.redirect || "/");
            throw e;
          });
      }
    },
    FBlogin() {
      let self = this;
      FB.login(
        function (response) {
          // handle the response
          // console.log(response)
          if (response.authResponse) {
            const userFB = {
              user_id: response.authResponse.userID,
              access_token: response.authResponse.accessToken,
            };
            self.$store
              .dispatch("FBlogin", userFB)
              .then(() => {
                window.alert("已登入，重新跳轉頁面");
                self.$router.push(self.$route.query.redirect || "/");
              })
              .catch((e) => {
                alert("登入失敗");
                throw e;
              });
          }
        },
        { scope: "public_profile" }
      );
    },
    statusChangeCallback(response) {
      // Called with the results from FB.getLoginStatus().
      // console.log('statusChangeCallback');
      // console.log(response);                   // The current login status of the person.
      if (response.status === "connected") {
        // Logged into your webpage and Facebook.
        this.testAPI();
      } else {
        // Not logged into your webpage or we are unable to tell.
        // document.getElementById('status').innerHTML = 'Please log ' +
        //   'into this webpage.';
        // console.log('Please log into this webpage.')
      }
    },
    checkLoginState() {
      // console.log('second')             // Called when a person is finished with the Login Button.
      FB.getLoginStatus(function (response) {
        // See the onlogin handler
        this.statusChangeCallback(response);
      });
    },
    testAPI() {
      // Testing Graph API after login.  See statusChangeCallback() for when this call is made.
      // console.log('Welcome!  Fetching your information.... ');
      FB.api("/me", function (response) {
        // console.log('Successful login for: ' + response.name);
        // document.getElementById('status').innerHTML =
        //   'Thanks for logging in, ' + response.name + '!';
        // console.log('Successful login')
        // console.log(response)
      });
    },
  },
  components: { AccesskeyLink },
};
</script>

<style lang="scss" scoped>
button {
  border: none;
}

.contentBlock {
  margin: auto;
  width: 280px;
  @include for-tablet {
    width: 522px;
  }

  @include for-tablet-horizontal {
    padding-top: 40px;
    padding-bottom: 10px;
  }
}

.title {
  margin: 20px 0 40px;
  font-family: $text-font-family;
  font-size: 24px;
  color: $color-light-text;
  text-align: center;
  letter-spacing: 1.14px;

  @include for-tablet {
    font-size: 32px;
    margin-top: 20px;
  }
}

.divider {
  color: $color-light-text;
  font-size: 16px;
  font-family: $text-font-family;
  margin-bottom: 30px;
  width: 100%;
  position: relative;
  text-align: center;
  &:after,
  &:before {
    content: " ";
    background-color: $color-light-btn-bg;
    height: 1px;
    width: 45%;
    position: absolute;
    top: 10px;
  }
  &:after {
    right: 0;
  }
  &:before {
    left: 0;
  }
}

.formBlock {
  .formLabel {
    color: $color-light-text;
    font-size: 21px;
    letter-spacing: 1.71px;
    font-family: $text-font-family;
  }

  .inputLayout {
    border: 1px solid $color-light-border;
    width: 100%;
    height: 50px;
    padding: 10px 30px;
    margin-top: 10px;
    margin-bottom: 30px;
    font-size: 18px;
    color: #979797;
    border-radius: 25px;
    box-sizing: border-box;
    &::placeholder {
      color: #979797;
    }
  }
}

.loginBtn {
  width: 100%;
  padding: 10px;
  height: 50px;
  box-sizing: border-box;
  border-radius: 32px;
  cursor: pointer;
  font-size: 21px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  letter-spacing: 1.5px;

  img {
    width: 21px;
    margin-right: 10px;
  }
}

.fbLayout {
  background-color: #4267b2;
}

.loginLayout {
  background-color: $color-light-btn-bg;
}

.additionAction {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0 40px;

  @include for-tablet {
    flex-direction: row;
    margin-bottom: 60px;
    a + a {
      margin-top: 0;
    }
  }

  a {
    color: $color-light-text;
    text-decoration: underline;
    & + a {
      margin-top: 20px;
    }
  }
}
</style>
